import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import { withPopup } from '../../lib/popup';
import { FilePicker, Popup } from '../../lib/custom-ui';

import styles from './AttachmentAddPopup.module.scss';

// eslint-disable-next-line no-unused-vars
const AttachmentAddStep = React.memo(({ onCreate, onClose }) => {
  const handleFileSelect = useCallback(
    (files) => {
      if (files[0]) {
        Object.values(files).forEach((file) => {
          onCreate({
            file,
          });
        });
      }
      onClose();
    },
    [onCreate, onClose],
  );

  return (
    <>
      <Popup.Header>附件</Popup.Header>
      <Popup.Content>
        <Menu secondary vertical className={styles.menu}>
          <FilePicker onSelect={handleFileSelect} isMultiple>
            <Menu.Item className={styles.menuItem}>从电脑</Menu.Item>
          </FilePicker>
        </Menu>
        <hr className={styles.divider} />
        <div className={styles.tip}>按下粘贴快捷键从剪贴板添加附件</div>
      </Popup.Content>
    </>
  );
});

AttachmentAddStep.propTypes = {
  onCreate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withPopup(AttachmentAddStep);
